<template>
    <div>
      <div class="row">
        <base-input class="col-md-6"
                    label="Subject"
                    v-model="ticket.title"
                    placeholder="Subject">
        </base-input>
        <base-input
                    class="col-md-6"
                    label="Priority">
          <select
                  :disabled="!isAuthor"
                  v-model="ticket.priority"
                  class="form-control">
            <option value="" disabled>Choose one</option>
            <option value="danger"  style="background-color: #f5365c; color: white">Danger </option>
            <option value="warning" style="background-color: #f96332; color: white">Warning</option>
            <option value="normal"  style="background-color: #40b27e; color: white">Normal </option>
            <option value="not-important" style="background-color: #3b5998; color: white">Not important</option>
          </select>
        </base-input>
      </div>
      <div class="row">
        <base-input class="col-md-6"
                    label="Date of creating the ticket"
                    v-model="beginDate"
                    disabled
                    placeholder="Date">
        </base-input>
        <base-input class="col-md-6"
                    label="Responsible Employee">
          <select class="form-control"
                  v-model="ticket['employee_id_to']"
                  :disabled="!isAuthor">
            <option value="0" disabled>Choose employee</option>
            <option v-for="employee in employees" :value="employee.employee_id" :key="employee.employee_id">{{employee.first_name + ' ' + employee.last_name}}</option>
          </select>
        </base-input>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="isAuthor">
          <my-data-picker :date="finalDate" label="Final date"></my-data-picker>
        </div>
        <base-input v-else
                    class       = "col-md-12"
                    label       = "Final date"
                    v-model     = "finalDate.date"
                    placeholder = "Date"
                    disabled>
        </base-input>
      </div>
      <div class="row">
        <base-input class="col-md-12"
                    label="Detailed the ticket's description">
          <blockquote class="blockquote">
          <textarea style="min-height: 400px; padding: 0;"
                    rows="10" cols="180"
                    class="form-control"
                    placeholder="Describe your problems or concerns"
                    v-model="ticket.text">
          </textarea>
          </blockquote>
        </base-input>
      </div>
      <div class="row">
        <div class="col-md-4">
          <base-button class="clock-button" simple block :disabled="!isAuthor" type="success" @click="save">
            Save
          </base-button>
        </div>
      </div>
    </div>
</template>

<script>
  import MyDataPicker from "../../components/DataPicker";
    export default {
      name: "TicketBody",
      components: {MyDataPicker},
      props: ['ticket', 'isAuthor', 'employees',"finalDate"],
      data(){
        return{
          beginDate: this.getDate(this.ticket['beginning_date']).toLocaleDateString("en-US"),
        }
      },
      methods :{
        getDate(date){
          return new Date(date.split('-').join('/'));
        },
        save(){
          this.$emit('save')
        },
      },

    }
</script>

<style scoped>
  label{
    color: #9d2fff;
    font-size: 16px;
  }
  .control-label{
    color:#f5365c !important;
    font-size: 18px;
  }

</style>
